module.exports = __webpack_public_path__ + "img/background-welcome@2x.6049c39a.jpg";